import gql from "graphql-tag";

export const GET_COUNTRY_COLORS = gql`
  subscription GET_COUNTRY_COLORS {
    colors {
      color
    }
  }
`;
